module.exports = __webpack_public_path__ + "img/four3Green.d704d368.jpg";